$ = require 'jquery'
Auth = require 'db/auth'
Version = require 'common/lib/version'

module.exports = ClientVersion =
  version: new Version.Client(window.clientVersion)
  # NOTE: The server stopped sending us the version along
  # with sockets, so this isn't always getting set/updated.
  # Don't use the environment for an actual dev/prod check. :(
  server:
    version: '0.0.0'
    environment: 'dev'

  setServerVersionFromResponse: (httpRequest) ->
    version = httpRequest.getResponseHeader('X-Trello-Version')
    environment = httpRequest.getResponseHeader('X-Trello-Environment')
    if version?
      @server.version = version
    if environment?
      @server.environment = environment

Object.defineProperty window, 'TrelloVersion', get: ->
  """
  Client: #{ ClientVersion.version } (#{ Auth.me().get('channels').active })
  """



// WEBPACK FOOTER //
// ./app/scripts/debug/client-version.coffee